var items = {
  "block.minecraft.air": "aiar",
  "block.minecraft.stone": "piere",
  "block.minecraft.granite": "granît",
  "block.minecraft.polished_granite": "granît lustrât",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "diorite lustrade",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "andesite lustrade",
  "block.minecraft.grass_block": "bloc di jerbe",
  "block.minecraft.dirt": "tiere",
  "block.minecraft.coarse_dirt": "tiere grese",
  "block.minecraft.podzol": "tiere grise",
  "block.minecraft.crimson_nylium": "neceli cremisin",
  "block.minecraft.warped_nylium": "neceli disnaturât",
  "block.minecraft.cobblestone": "claps",
  "block.minecraft.oak_planks": "breis di rôl",
  "block.minecraft.spruce_planks": "breis di peç",
  "block.minecraft.birch_planks": "breis di bedoi",
  "block.minecraft.jungle_planks": "breis di len di jungle",
  "block.minecraft.acacia_planks": "breis di agacie",
  "block.minecraft.dark_oak_planks": "breis di rôl scûr",
  "block.minecraft.crimson_planks": "breis cremisinis",
  "block.minecraft.warped_planks": "breis disnaturadis",
  "block.minecraft.oak_sapling": "arbossit di rôl",
  "block.minecraft.spruce_sapling": "arbossit di peç",
  "block.minecraft.birch_sapling": "arbossit di bedoi",
  "block.minecraft.jungle_sapling": "arbossit di jungle",
  "block.minecraft.acacia_sapling": "arbossit di agacie",
  "block.minecraft.dark_oak_sapling": "arbossit di rôl scûr",
  "block.minecraft.bedrock": "cret di fonts",
  "block.minecraft.sand": "savalon",
  "block.minecraft.red_sand": "savalon ros",
  "block.minecraft.gravel": "glerie",
  "block.minecraft.gold_ore": "minerâl di aur",
  "block.minecraft.iron_ore": "minerâl di fier",
  "block.minecraft.coal_ore": "minerâl di cjarbon",
  "block.minecraft.nether_gold_ore": "minerâl di aur dal nether",
  "block.minecraft.oak_log": "tronc di rôl",
  "block.minecraft.spruce_log": "tronc di peç",
  "block.minecraft.birch_log": "tronc di bedoi",
  "block.minecraft.jungle_log": "tronc di jungle",
  "block.minecraft.acacia_log": "tronc di agacie",
  "block.minecraft.dark_oak_log": "tronc di rôl scûr",
  "block.minecraft.crimson_stem": "tronc cremisin",
  "block.minecraft.warped_stem": "tronc disnaturât",
  "block.minecraft.stripped_oak_log": "tronc di rôl spelât",
  "block.minecraft.stripped_spruce_log": "tronc di peç spelât",
  "block.minecraft.stripped_birch_log": "tronc di bedoi spelât",
  "block.minecraft.stripped_jungle_log": "tronc di jungle spelât",
  "block.minecraft.stripped_acacia_log": "tronc di agacie spelât",
  "block.minecraft.stripped_dark_oak_log": "tronc di rôl scûr spelât",
  "block.minecraft.stripped_crimson_stem": "tronc cremisin spelât",
  "block.minecraft.stripped_warped_stem": "tronc disnaturât spelât",
  "block.minecraft.stripped_oak_wood": "len di rôl spelât",
  "block.minecraft.stripped_spruce_wood": "len di peç spelât",
  "block.minecraft.stripped_birch_wood": "len di bedoi spelât",
  "block.minecraft.stripped_jungle_wood": "len di jungle spelât",
  "block.minecraft.stripped_acacia_wood": "len di agacie spelât",
  "block.minecraft.stripped_dark_oak_wood": "len di rôl scûr spelât",
  "block.minecraft.stripped_crimson_hyphae": "ifis cremisinis sbroiadis",
  "block.minecraft.stripped_warped_hyphae": "ifis disnaturadis sbroiadis",
  "block.minecraft.oak_wood": "len di rôl",
  "block.minecraft.spruce_wood": "len di peç",
  "block.minecraft.birch_wood": "len di bedoi",
  "block.minecraft.jungle_wood": "len di jungle",
  "block.minecraft.acacia_wood": "len di agacie",
  "block.minecraft.dark_oak_wood": "len di rôl scûr",
  "block.minecraft.crimson_hyphae": "ifis cremisinis",
  "block.minecraft.warped_hyphae": "ifis disnaturadis",
  "block.minecraft.oak_leaves": "fueis di rôl",
  "block.minecraft.spruce_leaves": "fueis di peç",
  "block.minecraft.birch_leaves": "fueis di bedoi",
  "block.minecraft.jungle_leaves": "fueis di jungle",
  "block.minecraft.acacia_leaves": "fueis di agacie",
  "block.minecraft.dark_oak_leaves": "fueis di rôl scûr",
  "block.minecraft.sponge": "sponze",
  "block.minecraft.wet_sponge": "sponze bagnade",
  "block.minecraft.glass": "veri",
  "block.minecraft.lapis_ore": "minerâl di lapislazuli",
  "block.minecraft.lapis_block": "bloc di lapislazuli",
  "block.minecraft.dispenser": "distributôr",
  "block.minecraft.sandstone": "arenarie",
  "block.minecraft.chiseled_sandstone": "arenarie ceselade",
  "block.minecraft.cut_sandstone": "arenarie intaiade",
  "block.minecraft.note_block": "bloc sonôr",
  "block.minecraft.powered_rail": "sinis alimentadis",
  "block.minecraft.detector_rail": "sinis di rilevazion",
  "block.minecraft.sticky_piston": "piston tacadiç",
  "block.minecraft.cobweb": "tele di ragn",
  "block.minecraft.grass": "jerbe",
  "block.minecraft.fern": "felet",
  "block.minecraft.dead_bush": "sterp sec",
  "block.minecraft.seagrass": "jerbe dal mâr",
  "block.minecraft.sea_pickle": "cudumar di mâr",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "lane blancje",
  "block.minecraft.orange_wool": "lane naranç",
  "block.minecraft.magenta_wool": "lane magenta",
  "block.minecraft.light_blue_wool": "lane blu clâr",
  "block.minecraft.yellow_wool": "lane zale",
  "block.minecraft.lime_wool": "lane vert limon",
  "block.minecraft.pink_wool": "lane rose",
  "block.minecraft.gray_wool": "lane grise",
  "block.minecraft.light_gray_wool": "lane grîs clâr",
  "block.minecraft.cyan_wool": "lane ciano",
  "block.minecraft.purple_wool": "lane viole",
  "block.minecraft.blue_wool": "lane blu",
  "block.minecraft.brown_wool": "lane maron",
  "block.minecraft.green_wool": "lane verde",
  "block.minecraft.red_wool": "lane rosse",
  "block.minecraft.black_wool": "lane nere",
  "block.minecraft.dandelion": "tale",
  "block.minecraft.poppy": "papavar",
  "block.minecraft.blue_orchid": "orchidee blu",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonia caerulea",
  "block.minecraft.red_tulip": "tulipan ros",
  "block.minecraft.orange_tulip": "tulipan naranç",
  "block.minecraft.white_tulip": "tulipan blanc",
  "block.minecraft.pink_tulip": "tulipan rose",
  "block.minecraft.oxeye_daisy": "margarite",
  "block.minecraft.cornflower": "barburice",
  "block.minecraft.lily_of_the_valley": "sigjîl di salomon",
  "block.minecraft.wither_rose": "rose inflapide",
  "block.minecraft.brown_mushroom": "fonc maron",
  "block.minecraft.red_mushroom": "fonc ros",
  "block.minecraft.crimson_fungus": "fonc cremisin",
  "block.minecraft.warped_fungus": "fonc disnaturât",
  "block.minecraft.crimson_roots": "lidrîs crimisinis",
  "block.minecraft.warped_roots": "lidrîs disnaturadis",
  "block.minecraft.nether_sprouts": "menadis dal nether",
  "block.minecraft.weeping_vines": "rampighins vaiulints",
  "block.minecraft.twisting_vines": "rampighins intorteâts",
  "block.minecraft.sugar_cane": "cjane di sucar",
  "block.minecraft.kelp": "alighe",
  "block.minecraft.bamboo": "bambù",
  "block.minecraft.gold_block": "bloc di aur",
  "block.minecraft.iron_block": "bloc di fier",
  "block.minecraft.oak_slab": "lastre di rôl",
  "block.minecraft.spruce_slab": "lastre di peç",
  "block.minecraft.birch_slab": "lastre di bedoi",
  "block.minecraft.jungle_slab": "lastre di len di jungle",
  "block.minecraft.acacia_slab": "lastre di agacie",
  "block.minecraft.dark_oak_slab": "lastre di rôl scûr",
  "block.minecraft.crimson_slab": "lastre cremisine",
  "block.minecraft.warped_slab": "lastre disnaturade",
  "block.minecraft.stone_slab": "lastre di piere",
  "block.minecraft.smooth_stone_slab": "lastre di piere slisse",
  "block.minecraft.sandstone_slab": "lastre di arenarie",
  "block.minecraft.cut_sandstone_slab": "lastre di arenarie intaiade",
  "block.minecraft.petrified_oak_slab": "lastre di rôl impetride",
  "block.minecraft.cobblestone_slab": "lastre di claps",
  "block.minecraft.brick_slab": "lastre di modons",
  "block.minecraft.stone_brick_slab": "lastre di modons di piere",
  "block.minecraft.nether_brick_slab": "lastre di modons dal nether",
  "block.minecraft.quartz_slab": "lastre di cuarç",
  "block.minecraft.red_sandstone_slab": "lastre di arenarie rosse",
  "block.minecraft.cut_red_sandstone_slab": "lastre di arenarie rosse intaiade",
  "block.minecraft.purpur_slab": "lastre di purpur",
  "block.minecraft.prismarine_slab": "lastre di prismarine",
  "block.minecraft.prismarine_brick_slab": "lastre di modons di prismarine",
  "block.minecraft.dark_prismarine_slab": "lastre di prismarine scure",
  "block.minecraft.smooth_quartz": "bloc di cuarç slis",
  "block.minecraft.smooth_red_sandstone": "arearie rosse slisse",
  "block.minecraft.smooth_sandstone": "arenarie slisse",
  "block.minecraft.smooth_stone": "piere slisse",
  "block.minecraft.bricks": "modons",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "librarie",
  "block.minecraft.mossy_cobblestone": "claps cun muscli",
  "block.minecraft.obsidian": "ossidiane",
  "block.minecraft.torch": "torce",
  "block.minecraft.end_rod": "bachete dal end",
  "block.minecraft.chorus_plant": "plante corâl",
  "block.minecraft.chorus_flower": "rose corâl",
  "block.minecraft.purpur_block": "bloc di purpur",
  "block.minecraft.purpur_pillar": "pilastri di purpur",
  "block.minecraft.purpur_stairs": "scjalins di purpur",
  "block.minecraft.spawner": "gjeneradôr",
  "block.minecraft.oak_stairs": "scjalins di rôl",
  "block.minecraft.chest": "baûl",
  "block.minecraft.diamond_ore": "minerâl di diamant",
  "block.minecraft.diamond_block": "bloc di diamant",
  "block.minecraft.crafting_table": "banc di lavôr",
  "block.minecraft.farmland": "teren agricul",
  "block.minecraft.furnace": "fornâs",
  "block.minecraft.ladder": "scjale a man",
  "block.minecraft.rail": "sinis",
  "block.minecraft.cobblestone_stairs": "scjalins di claps",
  "block.minecraft.lever": "jeve",
  "block.minecraft.stone_pressure_plate": "plache di pression di piere",
  "block.minecraft.oak_pressure_plate": "plache di pression di rôl",
  "block.minecraft.spruce_pressure_plate": "plache di pression di peç",
  "block.minecraft.birch_pressure_plate": "plache di pression di bedoi",
  "block.minecraft.jungle_pressure_plate": "plache di pression di len di jungle",
  "block.minecraft.acacia_pressure_plate": "plache di pression di agacie",
  "block.minecraft.dark_oak_pressure_plate": "plache di pression di rôl scûr",
  "block.minecraft.crimson_pressure_plate": "plache di pression cremisine",
  "block.minecraft.warped_pressure_plate": "plache di pression disnaturade",
  "block.minecraft.polished_blackstone_pressure_plate": "plache di pression di pierenere lustrade",
  "block.minecraft.redstone_ore": "minerâl di piererosse",
  "block.minecraft.redstone_torch": "torce di piererosse",
  "block.minecraft.snow": "nêf",
  "block.minecraft.ice": "glace",
  "block.minecraft.snow_block": "bloc di nêf",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "arzile",
  "block.minecraft.jukebox": "zirediscs",
  "block.minecraft.oak_fence": "stangjaçade di rôl",
  "block.minecraft.spruce_fence": "stangjaçade di peç",
  "block.minecraft.birch_fence": "stangjaçade di bedoi",
  "block.minecraft.jungle_fence": "stangjaçade in len di jungle",
  "block.minecraft.acacia_fence": "stangjaçade di agacie",
  "block.minecraft.dark_oak_fence": "stangjaçade di rôl scûr",
  "block.minecraft.crimson_fence": "stangjaçade cremisine",
  "block.minecraft.warped_fence": "stangjaçade disnaturade",
  "block.minecraft.pumpkin": "coce",
  "block.minecraft.carved_pumpkin": "coce intaiade",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "savalon des animis",
  "block.minecraft.soul_soil": "tiere des animis",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt lustrât",
  "block.minecraft.soul_torch": "torce des animis",
  "block.minecraft.glowstone": "piere luminose",
  "block.minecraft.jack_o_lantern": "ferâl di coce",
  "block.minecraft.oak_trapdoor": "trabuchel di rôl",
  "block.minecraft.spruce_trapdoor": "trabuchel di peç",
  "block.minecraft.birch_trapdoor": "trabuchel di bedoi",
  "block.minecraft.jungle_trapdoor": "trabuchel di len di jungle",
  "block.minecraft.acacia_trapdoor": "trabuchel di agacie",
  "block.minecraft.dark_oak_trapdoor": "trabuchel di rôl scûr",
  "block.minecraft.crimson_trapdoor": "trabuchel cremisin",
  "block.minecraft.warped_trapdoor": "trabuchel disnaturât",
  "block.minecraft.infested_stone": "piere infestade",
  "block.minecraft.infested_cobblestone": "claps infestâts",
  "block.minecraft.infested_stone_bricks": "modons di piere infestâts",
  "block.minecraft.infested_mossy_stone_bricks": "modons di piere cun muscli infestâts",
  "block.minecraft.infested_cracked_stone_bricks": "modons di piere crepâts e infestâts",
  "block.minecraft.infested_chiseled_stone_bricks": "modons di piere ceselâts e infestâts",
  "block.minecraft.stone_bricks": "modons di piere",
  "block.minecraft.mossy_stone_bricks": "modons di piere cul muscli",
  "block.minecraft.cracked_stone_bricks": "modons di piere crepâts",
  "block.minecraft.chiseled_stone_bricks": "modons di piere ceselâts",
  "block.minecraft.brown_mushroom_block": "bloc di fonc maron",
  "block.minecraft.red_mushroom_block": "bloc di fonc ros",
  "block.minecraft.mushroom_stem": "gjambe di fonc",
  "block.minecraft.iron_bars": "sbaris di fier",
  "block.minecraft.chain": "cjadene",
  "block.minecraft.glass_pane": "panel di veri",
  "block.minecraft.melon": "angurie",
  "block.minecraft.vine": "plante rampighine",
  "block.minecraft.oak_fence_gate": "portonut di rôl",
  "block.minecraft.spruce_fence_gate": "portonut di peç",
  "block.minecraft.birch_fence_gate": "portonut di bedoi",
  "block.minecraft.jungle_fence_gate": "portonut in len di jungle",
  "block.minecraft.acacia_fence_gate": "portonut di agacie",
  "block.minecraft.dark_oak_fence_gate": "portonut di rôl scûr",
  "block.minecraft.crimson_fence_gate": "portonut cremisin",
  "block.minecraft.warped_fence_gate": "portonut disnaturât",
  "block.minecraft.brick_stairs": "scjalins di modons",
  "block.minecraft.stone_brick_stairs": "scjalins di modons di piere",
  "block.minecraft.mycelium": "miceli",
  "block.minecraft.lily_pad": "lavaç di aghe",
  "block.minecraft.nether_bricks": "modons dal nether",
  "block.minecraft.cracked_nether_bricks": "modons dal nether crepâts",
  "block.minecraft.chiseled_nether_bricks": "modons dal nether ceselâts",
  "block.minecraft.nether_brick_fence": "stangjaçade di modons dal nether",
  "block.minecraft.nether_brick_stairs": "scjalins di modons dal nether",
  "block.minecraft.enchanting_table": "banc par incjantesims",
  "block.minecraft.end_portal_frame": "curnîs dal portâl dal end",
  "block.minecraft.end_stone": "piere dal end",
  "block.minecraft.end_stone_bricks": "modons di piere dal end",
  "block.minecraft.dragon_egg": "ûf di drâc",
  "block.minecraft.redstone_lamp": "lampade di piererosse",
  "block.minecraft.sandstone_stairs": "scjalins di arenarie",
  "block.minecraft.emerald_ore": "minerâl di smeralt",
  "block.minecraft.ender_chest": "baûl dal end",
  "block.minecraft.tripwire_hook": "ganç pal fîl di lescjament",
  "block.minecraft.emerald_block": "bloc di smeralt",
  "block.minecraft.spruce_stairs": "scjalins di peç",
  "block.minecraft.birch_stairs": "scjalins di bedoi",
  "block.minecraft.jungle_stairs": "scjalins di len di jungle",
  "block.minecraft.crimson_stairs": "scjalins cremisins",
  "block.minecraft.warped_stairs": "scjalins disnaturâts",
  "block.minecraft.command_block": "bloc comants",
  "block.minecraft.beacon": "fâr",
  "block.minecraft.cobblestone_wall": "muret di claps",
  "block.minecraft.mossy_cobblestone_wall": "muret di claps cul muscli",
  "block.minecraft.brick_wall": "muret di modons",
  "block.minecraft.prismarine_wall": "muret di prismarine",
  "block.minecraft.red_sandstone_wall": "muret di arenarie rosse",
  "block.minecraft.mossy_stone_brick_wall": "muret di modons di piere cun muscli",
  "block.minecraft.granite_wall": "muret di granît",
  "block.minecraft.stone_brick_wall": "muret di modons di piere",
  "block.minecraft.nether_brick_wall": "muret di modons dal nether",
  "block.minecraft.andesite_wall": "muret di andesite",
  "block.minecraft.red_nether_brick_wall": "muret di modons ros dal nether",
  "block.minecraft.sandstone_wall": "muret di arenarie",
  "block.minecraft.end_stone_brick_wall": "muret di modons di piere dal end",
  "block.minecraft.diorite_wall": "muret di diorite",
  "block.minecraft.blackstone_wall": "muret di pierenere",
  "block.minecraft.polished_blackstone_wall": "muret di pierenere lustrade",
  "block.minecraft.polished_blackstone_brick_wall": "muret di modons di pierenere lustrade",
  "block.minecraft.stone_button": "boton di piere",
  "block.minecraft.oak_button": "boton di rôl",
  "block.minecraft.spruce_button": "boton di peç",
  "block.minecraft.birch_button": "boton di bedoi",
  "block.minecraft.jungle_button": "boton di len di jungle",
  "block.minecraft.acacia_button": "boton di agacie",
  "block.minecraft.dark_oak_button": "boton di rôl scûr",
  "block.minecraft.crimson_button": "boton cremisin",
  "block.minecraft.warped_button": "boton disnaturât",
  "block.minecraft.polished_blackstone_button": "boton di pierenere lustrade",
  "block.minecraft.anvil": "incuin",
  "block.minecraft.chipped_anvil": "incuin sclesât",
  "block.minecraft.damaged_anvil": "incuin ruvinât",
  "block.minecraft.trapped_chest": "baûl trapule",
  "block.minecraft.light_weighted_pressure_plate": "plache di pression par pês lizêrs",
  "block.minecraft.heavy_weighted_pressure_plate": "plache di pression par pês elevâts",
  "block.minecraft.daylight_detector": "rilevadôr lûs diurne",
  "block.minecraft.redstone_block": "bloc di piererosse",
  "block.minecraft.nether_quartz_ore": "minerâl di cuarç dal nether",
  "block.minecraft.hopper": "tramuele",
  "block.minecraft.chiseled_quartz_block": "bloc di cuarç ceselât",
  "block.minecraft.quartz_block": "bloc di cuarç",
  "block.minecraft.quartz_bricks": "modons di cuarç",
  "block.minecraft.quartz_pillar": "pilastri di cuarç",
  "block.minecraft.quartz_stairs": "scjalins di cuarç",
  "block.minecraft.activator_rail": "sinis di ativazion",
  "block.minecraft.dropper": "tiradôr",
  "block.minecraft.white_terracotta": "crep blanc",
  "block.minecraft.orange_terracotta": "crep naranç",
  "block.minecraft.magenta_terracotta": "crep magenta",
  "block.minecraft.light_blue_terracotta": "crep blu clâr",
  "block.minecraft.yellow_terracotta": "crep zâl",
  "block.minecraft.lime_terracotta": "crep vert limon",
  "block.minecraft.pink_terracotta": "crep rose",
  "block.minecraft.gray_terracotta": "crep grîs",
  "block.minecraft.light_gray_terracotta": "crep grîs clâr",
  "block.minecraft.cyan_terracotta": "crep ciano",
  "block.minecraft.purple_terracotta": "crep viole",
  "block.minecraft.blue_terracotta": "crep blu",
  "block.minecraft.brown_terracotta": "crep maron",
  "block.minecraft.green_terracotta": "crep vert",
  "block.minecraft.red_terracotta": "crep ros",
  "block.minecraft.black_terracotta": "crep neri",
  "block.minecraft.barrier": "bariere",
  "block.minecraft.iron_trapdoor": "trabuchel di fier",
  "block.minecraft.hay_block": "bale di fen",
  "block.minecraft.white_carpet": "tapêt blanc",
  "block.minecraft.orange_carpet": "tapêt naranç",
  "block.minecraft.magenta_carpet": "tapêt magenta",
  "block.minecraft.light_blue_carpet": "tapêt blu clâr",
  "block.minecraft.yellow_carpet": "tapêt zâl",
  "block.minecraft.lime_carpet": "tapêt vert limon",
  "block.minecraft.pink_carpet": "tapêt rose",
  "block.minecraft.gray_carpet": "tapêt grîs",
  "block.minecraft.light_gray_carpet": "tapêt grîs clâr",
  "block.minecraft.cyan_carpet": "tapêt ciano",
  "block.minecraft.purple_carpet": "tapêt viole",
  "block.minecraft.blue_carpet": "tapêt blu",
  "block.minecraft.brown_carpet": "tapêt maron",
  "block.minecraft.green_carpet": "tapêt vert",
  "block.minecraft.red_carpet": "tapêt ros",
  "block.minecraft.black_carpet": "tapêt neri",
  "block.minecraft.terracotta": "crep",
  "block.minecraft.coal_block": "bloc di cjarbon",
  "block.minecraft.packed_ice": "glaç pressât",
  "block.minecraft.acacia_stairs": "scjalins di agacie",
  "block.minecraft.dark_oak_stairs": "scjalins di rôl scûr",
  "block.minecraft.slime_block": "bloc di gjeladine",
  "block.minecraft.grass_path": "troi",
  "block.minecraft.sunflower": "gjirasol",
  "block.minecraft.lilac": "lile",
  "block.minecraft.rose_bush": "baraç di rosis",
  "block.minecraft.peony": "peonie",
  "block.minecraft.tall_grass": "jerbe alte",
  "block.minecraft.large_fern": "felet grant",
  "block.minecraft.white_stained_glass": "veri colorât di blanc",
  "block.minecraft.orange_stained_glass": "veri colorât di naranç",
  "block.minecraft.magenta_stained_glass": "veri colorât di magenta",
  "block.minecraft.light_blue_stained_glass": "veri colorât di blu clâr",
  "block.minecraft.yellow_stained_glass": "veri colorât di zâl",
  "block.minecraft.lime_stained_glass": "veri colorât di vert limon",
  "block.minecraft.pink_stained_glass": "veri colorât di rose",
  "block.minecraft.gray_stained_glass": "veri colorât di grîs",
  "block.minecraft.light_gray_stained_glass": "veri colorât di grîs clâr",
  "block.minecraft.cyan_stained_glass": "veri colorât di ciano",
  "block.minecraft.purple_stained_glass": "veri colorât di viole",
  "block.minecraft.blue_stained_glass": "veri colorât di blu",
  "block.minecraft.brown_stained_glass": "veri colorât di maron",
  "block.minecraft.green_stained_glass": "veri colorât di vert",
  "block.minecraft.red_stained_glass": "veri colorât di ros",
  "block.minecraft.black_stained_glass": "veri colorât di neri",
  "block.minecraft.white_stained_glass_pane": "panel di veri colôr blanc",
  "block.minecraft.orange_stained_glass_pane": "panel di veri colôr naranç",
  "block.minecraft.magenta_stained_glass_pane": "panel di veri colôr magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panel di veri colôr blu clâr",
  "block.minecraft.yellow_stained_glass_pane": "panel di veri colôr zâl",
  "block.minecraft.lime_stained_glass_pane": "panel di veri colôr vert limon",
  "block.minecraft.pink_stained_glass_pane": "panel di veri colôr rose",
  "block.minecraft.gray_stained_glass_pane": "panel di veri colôr grîs",
  "block.minecraft.light_gray_stained_glass_pane": "panel di veri colôr grîs clâr",
  "block.minecraft.cyan_stained_glass_pane": "panel di veri colôr ciano",
  "block.minecraft.purple_stained_glass_pane": "panel di veri colôr viole",
  "block.minecraft.blue_stained_glass_pane": "panel di veri colôr blu",
  "block.minecraft.brown_stained_glass_pane": "panel di veri colôr maron",
  "block.minecraft.green_stained_glass_pane": "panel di veri colôr vert",
  "block.minecraft.red_stained_glass_pane": "panel di veri colôr ros",
  "block.minecraft.black_stained_glass_pane": "panel di veri colôr neri",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "modons di prismarine",
  "block.minecraft.dark_prismarine": "prismarine scure",
  "block.minecraft.prismarine_stairs": "scjalins di prismarine",
  "block.minecraft.prismarine_brick_stairs": "scjalins di modons di prismarine",
  "block.minecraft.dark_prismarine_stairs": "scjalins di prismarine scure",
  "block.minecraft.sea_lantern": "ferâl dai mârs",
  "block.minecraft.red_sandstone": "arenarie rosse",
  "block.minecraft.chiseled_red_sandstone": "arenarie rosse ceselade",
  "block.minecraft.cut_red_sandstone": "arenarie rosse intaiade",
  "block.minecraft.red_sandstone_stairs": "scjalins di arenarie rosse",
  "block.minecraft.repeating_command_block": "bloc comants ripetûts",
  "block.minecraft.chain_command_block": "bloc comants concatenâts",
  "block.minecraft.magma_block": "bloc di magme",
  "block.minecraft.nether_wart_block": "bloc di riçûi dal nether",
  "block.minecraft.warped_wart_block": "bloc di riçûi disnaturât",
  "block.minecraft.red_nether_bricks": "modons ros dal nether",
  "block.minecraft.bone_block": "bloc di vues",
  "block.minecraft.structure_void": "vueit di struture",
  "block.minecraft.observer": "osservadôr",
  "block.minecraft.shulker_box": "scjatule di shulker",
  "block.minecraft.white_shulker_box": "scjatule di shulker blancje",
  "block.minecraft.orange_shulker_box": "scjatule di shulker naranç",
  "block.minecraft.magenta_shulker_box": "scjatule di shulker magenta",
  "block.minecraft.light_blue_shulker_box": "scjatule di shulker blu clâr",
  "block.minecraft.yellow_shulker_box": "scjatule di shulker zale",
  "block.minecraft.lime_shulker_box": "scjatule di shulker vert limon",
  "block.minecraft.pink_shulker_box": "scjatule di shulker rose",
  "block.minecraft.gray_shulker_box": "scjatule di shulker grise",
  "block.minecraft.light_gray_shulker_box": "scjatule di shulker grîs clâr",
  "block.minecraft.cyan_shulker_box": "scjatule di shulker ciano",
  "block.minecraft.purple_shulker_box": "scjatule di shulker viole",
  "block.minecraft.blue_shulker_box": "scjatule di shulker blu",
  "block.minecraft.brown_shulker_box": "scjatule di shulker maron",
  "block.minecraft.green_shulker_box": "scjatule di shulker verde",
  "block.minecraft.red_shulker_box": "scjatule di shulker rosse",
  "block.minecraft.black_shulker_box": "scjatule di shulker nere",
  "block.minecraft.white_glazed_terracotta": "crep dât di smalt blanc",
  "block.minecraft.orange_glazed_terracotta": "crep dât di smalt naranç",
  "block.minecraft.magenta_glazed_terracotta": "crep dât di smalt magenta",
  "block.minecraft.light_blue_glazed_terracotta": "crep dât di smalt blu clâr",
  "block.minecraft.yellow_glazed_terracotta": "crep dât di smalt zâl",
  "block.minecraft.lime_glazed_terracotta": "crep dât di smalt vert limon",
  "block.minecraft.pink_glazed_terracotta": "crep dât di smalt rose",
  "block.minecraft.gray_glazed_terracotta": "crep dât di smalt grîs",
  "block.minecraft.light_gray_glazed_terracotta": "crep dât di smalt grîs clâr",
  "block.minecraft.cyan_glazed_terracotta": "crep dât di smalt ciano",
  "block.minecraft.purple_glazed_terracotta": "crep dât di smalt viole",
  "block.minecraft.blue_glazed_terracotta": "crep dât di smalt blu",
  "block.minecraft.brown_glazed_terracotta": "crep dât di smalt maron",
  "block.minecraft.green_glazed_terracotta": "crep dât di smalt vert",
  "block.minecraft.red_glazed_terracotta": "crep dât di smalt ros",
  "block.minecraft.black_glazed_terracotta": "crep dât di smalt neri",
  "block.minecraft.white_concrete": "beton blanc",
  "block.minecraft.orange_concrete": "beton naranç",
  "block.minecraft.magenta_concrete": "beton magenta",
  "block.minecraft.light_blue_concrete": "beton blu clâr",
  "block.minecraft.yellow_concrete": "beton zâl",
  "block.minecraft.lime_concrete": "beton vert limon",
  "block.minecraft.pink_concrete": "beton rose",
  "block.minecraft.gray_concrete": "beton grîs",
  "block.minecraft.light_gray_concrete": "beton grîs clâr",
  "block.minecraft.cyan_concrete": "beton ciano",
  "block.minecraft.purple_concrete": "beton viole",
  "block.minecraft.blue_concrete": "beton blu",
  "block.minecraft.brown_concrete": "beton maron",
  "block.minecraft.green_concrete": "beton vert",
  "block.minecraft.red_concrete": "beton ros",
  "block.minecraft.black_concrete": "beton neri",
  "block.minecraft.white_concrete_powder": "beton blanc in polvar",
  "block.minecraft.orange_concrete_powder": "beton naranç in polvar",
  "block.minecraft.magenta_concrete_powder": "beton magenta in polvar",
  "block.minecraft.light_blue_concrete_powder": "beton blu clâr in polvar",
  "block.minecraft.yellow_concrete_powder": "beton zâl in polvar",
  "block.minecraft.lime_concrete_powder": "beton vert limon in polvar",
  "block.minecraft.pink_concrete_powder": "beton rose in polvar",
  "block.minecraft.gray_concrete_powder": "beton grîs in polvar",
  "block.minecraft.light_gray_concrete_powder": "beton grîs clâr in polvar",
  "block.minecraft.cyan_concrete_powder": "beton ciano in polvar",
  "block.minecraft.purple_concrete_powder": "beton viole in polvar",
  "block.minecraft.blue_concrete_powder": "beton blu in polvar",
  "block.minecraft.brown_concrete_powder": "beton maron in polvar",
  "block.minecraft.green_concrete_powder": "beton vert in polvar",
  "block.minecraft.red_concrete_powder": "beton ros in polvar",
  "block.minecraft.black_concrete_powder": "beton neri in polvar",
  "block.minecraft.turtle_egg": "ûf di copasse",
  "block.minecraft.dead_tube_coral_block": "bloc di coral dai tubui muart",
  "block.minecraft.dead_brain_coral_block": "bloc di coral dai cerviei muart",
  "block.minecraft.dead_bubble_coral_block": "bloc di coral des bufulis muart",
  "block.minecraft.dead_fire_coral_block": "bloc di coral des flamis muart",
  "block.minecraft.dead_horn_coral_block": "bloc di coral dai cuars muart",
  "block.minecraft.tube_coral_block": "bloc di coral dai tubui",
  "block.minecraft.brain_coral_block": "bloc di coral dai cerviei",
  "block.minecraft.bubble_coral_block": "bloc di coral des bufulis",
  "block.minecraft.fire_coral_block": "bloc di coral des flamis",
  "block.minecraft.horn_coral_block": "bloc di coral dai cuars",
  "block.minecraft.tube_coral": "coral dai tubui",
  "block.minecraft.brain_coral": "coral dai cerviei",
  "block.minecraft.bubble_coral": "coral des bufulis",
  "block.minecraft.fire_coral": "coral des flamis",
  "block.minecraft.horn_coral": "coral dai cuars",
  "block.minecraft.dead_brain_coral": "coral dai cerviei muart",
  "block.minecraft.dead_bubble_coral": "coral des bufulis muart",
  "block.minecraft.dead_fire_coral": "coral des flamis muart",
  "block.minecraft.dead_horn_coral": "coral dai cuars muart",
  "block.minecraft.dead_tube_coral": "coral dai tubui muart",
  "block.minecraft.tube_coral_fan": "gorgonie dal coral dai tubui",
  "block.minecraft.brain_coral_fan": "gorgonie dal coral dai cerviei",
  "block.minecraft.bubble_coral_fan": "gorgonie dal coral des bufulis",
  "block.minecraft.fire_coral_fan": "gorgonie dal coral des flamis",
  "block.minecraft.horn_coral_fan": "gorgonie dal coral dai cuars",
  "block.minecraft.dead_tube_coral_fan": "gorgonie dal coral dai tubui muart",
  "block.minecraft.dead_brain_coral_fan": "gorgonie dal coral dai cerviei muart",
  "block.minecraft.dead_bubble_coral_fan": "gorgonie dal coral des bufulis muart",
  "block.minecraft.dead_fire_coral_fan": "gorgonie dal coral des flamis muart",
  "block.minecraft.dead_horn_coral_fan": "gorgonie dal coral dai cuars muart",
  "block.minecraft.blue_ice": "glaç blu",
  "block.minecraft.conduit": "condot",
  "block.minecraft.polished_granite_stairs": "scjalins di granît lustrât",
  "block.minecraft.smooth_red_sandstone_stairs": "scjalins di arenarie rosse slisse",
  "block.minecraft.mossy_stone_brick_stairs": "scjalins di modons di piere cun muscli",
  "block.minecraft.polished_diorite_stairs": "scjalins di diorite lustrade",
  "block.minecraft.mossy_cobblestone_stairs": "scjalins di claps cun muscli",
  "block.minecraft.end_stone_brick_stairs": "scjalins di modons di piere dal end",
  "block.minecraft.stone_stairs": "scjalins di piere",
  "block.minecraft.smooth_sandstone_stairs": "scjalins di arenarie slisse",
  "block.minecraft.smooth_quartz_stairs": "scjalins di cuarç slis",
  "block.minecraft.granite_stairs": "scjalins di granît",
  "block.minecraft.andesite_stairs": "scjalins di andesite",
  "block.minecraft.red_nether_brick_stairs": "scjalins di modons ros dal nether",
  "block.minecraft.polished_andesite_stairs": "scjalins di andesite lustrade",
  "block.minecraft.diorite_stairs": "scjalins di diorite",
  "block.minecraft.polished_granite_slab": "lastre di granît lustrât",
  "block.minecraft.smooth_red_sandstone_slab": "lastre di arenarie rosse slisse",
  "block.minecraft.mossy_stone_brick_slab": "lastre di modons di piere cun muscli",
  "block.minecraft.polished_diorite_slab": "lastre di diorite lustrade",
  "block.minecraft.mossy_cobblestone_slab": "lastre di claps cun muscli",
  "block.minecraft.end_stone_brick_slab": "lastre di modons di piere dal end",
  "block.minecraft.smooth_sandstone_slab": "lastre di arenarie slisse",
  "block.minecraft.smooth_quartz_slab": "lastre di cuarç slis",
  "block.minecraft.granite_slab": "lastre di granît",
  "block.minecraft.andesite_slab": "lastre di andesite",
  "block.minecraft.red_nether_brick_slab": "lastre di modons ros dal nether",
  "block.minecraft.polished_andesite_slab": "lastre di andesite lustrade",
  "block.minecraft.diorite_slab": "lastre di diorite",
  "block.minecraft.scaffolding": "impalcadure",
  "block.minecraft.iron_door": "puarte di fier",
  "block.minecraft.oak_door": "puarte di rôl",
  "block.minecraft.spruce_door": "puarte di peç",
  "block.minecraft.birch_door": "puarte di bedoi",
  "block.minecraft.jungle_door": "puarte di len di jungle",
  "block.minecraft.acacia_door": "puarte di agacie",
  "block.minecraft.dark_oak_door": "puarte di rôl scûr",
  "block.minecraft.crimson_door": "puarte cremisine",
  "block.minecraft.warped_door": "puarte disnaturade",
  "block.minecraft.repeater": "ripetidôr di piererosse",
  "block.minecraft.comparator": "comparadôr di piererosse",
  "block.minecraft.structure_block": "bloc di struture",
  "block.minecraft.jigsaw": "bloc berdei",
  "item.minecraft.turtle_helmet": "casc di copasse□□sul cjâf:□+2 ponts di armadure",
  "item.minecraft.scute": "toc di scus",
  "item.minecraft.iron_shovel": "pale di fier□□te man principâl:□+3.5 dams di atac□-3 velocitât di atac",
  "item.minecraft.iron_pickaxe": "picon di fier□□te man principâl:□+3 dams di atac□-2.8 velocitât di atac",
  "item.minecraft.iron_axe": "manarie di fier□□te man principâl:□+8 dams di atac□-3.1 velocitât di atac",
  "item.minecraft.flint_and_steel": "açalin",
  "item.minecraft.apple": "miluç",
  "item.minecraft.bow": "arc",
  "item.minecraft.arrow": "frece",
  "item.minecraft.coal": "cjarbon",
  "item.minecraft.charcoal": "carbonele",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "lingot di fier",
  "item.minecraft.gold_ingot": "lingot di aur",
  "item.minecraft.netherite_ingot": "lingot di netherite",
  "item.minecraft.netherite_scrap": "rotum di netherite",
  "item.minecraft.iron_sword": "spade di fier□□te man principâl:□+5 dams di atac□-2.4 velocitât di atac",
  "item.minecraft.wooden_sword": "spade di len□□te man principâl:□+3 dams di atac□-2.4 velocitât di atac",
  "item.minecraft.wooden_shovel": "pale di len□□te man principâl:□+1.5 dams di atac□-3 velocitât di atac",
  "item.minecraft.wooden_pickaxe": "picon di len□□te man principâl:□+1 dams di atac□-2.8 velocitât di atac",
  "item.minecraft.wooden_axe": "manarie di len□□te man principâl:□+6 dams di atac□-3.2 velocitât di atac",
  "item.minecraft.stone_sword": "spade di piere□□te man principâl:□+4 dams di atac□-2.4 velocitât di atac",
  "item.minecraft.stone_shovel": "pale di piere□□te man principâl:□+2.5 dams di atac□-3 velocitât di atac",
  "item.minecraft.stone_pickaxe": "picon di piere□□te man principâl:□+2 dams di atac□-2.8 velocitât di atac",
  "item.minecraft.stone_axe": "manarie di piere□□te man principâl:□+8 dams di atac□-3.2 velocitât di atac",
  "item.minecraft.diamond_sword": "spade di diamant□□te man principâl:□+6 dams di atac□-2.4 velocitât di atac",
  "item.minecraft.diamond_shovel": "pale di diamant□□te man principâl:□+4.5 dams di atac□-3 velocitât di atac",
  "item.minecraft.diamond_pickaxe": "picon di diamant□□te man principâl:□+4 dams di atac□-2.8 velocitât di atac",
  "item.minecraft.diamond_axe": "manarie di diamant□□te man principâl:□+8 dams di atac□-3 velocitât di atac",
  "item.minecraft.stick": "stec",
  "item.minecraft.bowl": "scudiele",
  "item.minecraft.mushroom_stew": "sope di foncs",
  "item.minecraft.golden_sword": "spade di aur□□te man principâl:□+3 dams di atac□-2.4 velocitât di atac",
  "item.minecraft.golden_shovel": "pale di aur□□te man principâl:□+1.5 dams di atac□-3 velocitât di atac",
  "item.minecraft.golden_pickaxe": "picon di aur□□te man principâl:□+1 dams di atac□-2.8 velocitât di atac",
  "item.minecraft.golden_axe": "manarie di aur□□te man principâl:□+6 dams di atac□-3 velocitât di atac",
  "item.minecraft.netherite_sword": "spade in netherite□□te man principâl:□+7 dams di atac□-2.4 velocitât di atac",
  "item.minecraft.netherite_shovel": "pale in netherite□□te man principâl:□+5.5 dams di atac□-3 velocitât di atac",
  "item.minecraft.netherite_pickaxe": "picon in netherite□□te man principâl:□+5 dams di atac□-2.8 velocitât di atac",
  "item.minecraft.netherite_axe": "manarie in netherite□□te man principâl:□+9 dams di atac□-3 velocitât di atac",
  "item.minecraft.string": "cuardute",
  "item.minecraft.feather": "plume",
  "item.minecraft.gunpowder": "polvar di sclope",
  "item.minecraft.wooden_hoe": "sape di len□□te man principâl:□-3 velocitât di atac",
  "item.minecraft.stone_hoe": "sape di piere□□te man principâl:□-2 velocitât di atac",
  "item.minecraft.iron_hoe": "sape di fier□□te man principâl:□-1 velocitât di atac",
  "item.minecraft.diamond_hoe": "sape di diamant□□te man principâl:",
  "item.minecraft.golden_hoe": "sape di aur□□te man principâl:□-3 velocitât di atac",
  "item.minecraft.netherite_hoe": "sape in netherite□□te man principâl:",
  "item.minecraft.wheat_seeds": "semencis di forment",
  "item.minecraft.wheat": "forment",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "casc di corean□□sul cjâf:□+1 ponts di armadure",
  "item.minecraft.leather_chestplate": "gjubot di corean□□sul pet:□+3 ponts di armadure",
  "item.minecraft.leather_leggings": "bregons di corean□□su lis gjambis:□+2 ponts di armadure",
  "item.minecraft.leather_boots": "stivâi di corean□□sui pîts:□+1 ponts di armadure",
  "item.minecraft.chainmail_helmet": "elm in maie di fier□□sul cjâf:□+2 ponts di armadure",
  "item.minecraft.chainmail_chestplate": "usberc in maie di fier□□sul pet:□+5 ponts di armadure",
  "item.minecraft.chainmail_leggings": "braghesse in maie di fier□□su lis gjambis:□+4 ponts di armadure",
  "item.minecraft.chainmail_boots": "stivâi in maie di fier□□sui pîts:□+1 ponts di armadure",
  "item.minecraft.iron_helmet": "elm di fier□□sul cjâf:□+2 ponts di armadure",
  "item.minecraft.iron_chestplate": "corace di fier□□sul pet:□+6 ponts di armadure",
  "item.minecraft.iron_leggings": "gjambâi di fier□□su lis gjambis:□+5 ponts di armadure",
  "item.minecraft.iron_boots": "stivâi di fier□□sui pîts:□+2 ponts di armadure",
  "item.minecraft.diamond_helmet": "elm di diamant□□sul cjâf:□+3 ponts di armadure□+2 tignince de armadure",
  "item.minecraft.diamond_chestplate": "corace di diamant□□sul pet:□+8 ponts di armadure□+2 tignince de armadure",
  "item.minecraft.diamond_leggings": "gjambâi di diamant□□su lis gjambis:□+6 ponts di armadure□+2 tignince de armadure",
  "item.minecraft.diamond_boots": "stivâi di diamant□□sui pîts:□+3 ponts di armadure□+2 tignince de armadure",
  "item.minecraft.golden_helmet": "elm in aur□□sul cjâf:□+2 ponts di armadure",
  "item.minecraft.golden_chestplate": "corace in aur□□sul pet:□+5 ponts di armadure",
  "item.minecraft.golden_leggings": "gjambâi in aur□□su lis gjambis:□+3 ponts di armadure",
  "item.minecraft.golden_boots": "stivâi in aur□□sui pîts:□+1 ponts di armadure",
  "item.minecraft.netherite_helmet": "elm in netherite□□sul cjâf:□+3 ponts di armadure□+3 tignince de armadure□+1 resistence al cuintricolp",
  "item.minecraft.netherite_chestplate": "corace in netherite□□sul pet:□+8 ponts di armadure□+3 tignince de armadure□+1 resistence al cuintricolp",
  "item.minecraft.netherite_leggings": "gjambâi in netherite□□su lis gjambis:□+6 ponts di armadure□+3 tignince de armadure□+1 resistence al cuintricolp",
  "item.minecraft.netherite_boots": "stivâi in netherite□□sui pîts:□+3 ponts di armadure□+3 tignince de armadure□+1 resistence al cuintricolp",
  "item.minecraft.flint": "siliç",
  "item.minecraft.porkchop": "brusadule di purcit crude",
  "item.minecraft.cooked_porkchop": "brusadule di purcit cuete",
  "item.minecraft.painting": "cuadri",
  "item.minecraft.golden_apple": "miluç di aur",
  "item.minecraft.enchanted_golden_apple": "miluç di aur incjantât",
  "block.minecraft.oak_sign": "cartel di rôl",
  "block.minecraft.spruce_sign": "cartel di peç",
  "block.minecraft.birch_sign": "cartel di bedoi",
  "block.minecraft.jungle_sign": "cartel di len di jungle",
  "block.minecraft.acacia_sign": "cartel di agacie",
  "block.minecraft.dark_oak_sign": "cartel di rôl scûr",
  "block.minecraft.crimson_sign": "cartel cremisin",
  "block.minecraft.warped_sign": "cartel disnaturât",
  "item.minecraft.bucket": "seglot",
  "item.minecraft.water_bucket": "seglot di aghe",
  "item.minecraft.lava_bucket": "seglot di lave",
  "item.minecraft.minecart": "carel minerari",
  "item.minecraft.saddle": "siele",
  "item.minecraft.redstone": "polvar di piererosse",
  "item.minecraft.snowball": "bale di nêf",
  "item.minecraft.oak_boat": "barcje di rôl",
  "item.minecraft.leather": "corean",
  "item.minecraft.milk_bucket": "seglot di lat",
  "item.minecraft.pufferfish_bucket": "seglot cun pes-bale",
  "item.minecraft.salmon_bucket": "seglot cun salmon",
  "item.minecraft.cod_bucket": "seglot cun merluç",
  "item.minecraft.tropical_fish_bucket": "seglot cun pes tropicâl",
  "item.minecraft.brick": "modon",
  "item.minecraft.clay_ball": "bale di arzile",
  "block.minecraft.dried_kelp_block": "bloc di alighis secjadis",
  "item.minecraft.paper": "cjarte",
  "item.minecraft.book": "libri",
  "item.minecraft.slime_ball": "bale di gjeladine",
  "item.minecraft.chest_minecart": "carel minerari cun baûl",
  "item.minecraft.furnace_minecart": "carel minerari cun fornâs",
  "item.minecraft.egg": "ûf",
  "item.minecraft.compass": "bussule",
  "item.minecraft.fishing_rod": "cjane di pescje",
  "item.minecraft.clock": "orloi",
  "item.minecraft.glowstone_dust": "polvar di piere luminose",
  "item.minecraft.cod": "merluç crût",
  "item.minecraft.salmon": "salmon crût",
  "item.minecraft.tropical_fish": "pes tropicâl",
  "item.minecraft.pufferfish": "pes-bale",
  "item.minecraft.cooked_cod": "merluç cuet",
  "item.minecraft.cooked_salmon": "salmon cuet",
  "item.minecraft.ink_sac": "sache di ingjustri",
  "item.minecraft.red_dye": "tinture rosse",
  "item.minecraft.green_dye": "tinture verde",
  "item.minecraft.cocoa_beans": "favis di cacau",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "tinture viole",
  "item.minecraft.cyan_dye": "tinture ciano",
  "item.minecraft.light_gray_dye": "tinture grîs clâr",
  "item.minecraft.gray_dye": "tinture grise",
  "item.minecraft.pink_dye": "tinture rose",
  "item.minecraft.lime_dye": "tinture vert limon",
  "item.minecraft.yellow_dye": "tinture zale",
  "item.minecraft.light_blue_dye": "tinture blu clâr",
  "item.minecraft.magenta_dye": "tinture magenta",
  "item.minecraft.orange_dye": "tinture naranç",
  "item.minecraft.bone_meal": "farine di vues",
  "item.minecraft.blue_dye": "tinture blu",
  "item.minecraft.brown_dye": "tinture maron",
  "item.minecraft.black_dye": "tinture nere",
  "item.minecraft.white_dye": "tinture blancje",
  "item.minecraft.bone": "vues",
  "item.minecraft.sugar": "sucar",
  "block.minecraft.cake": "torte",
  "block.minecraft.white_bed": "jet blanc",
  "block.minecraft.orange_bed": "jet naranç",
  "block.minecraft.magenta_bed": "jet magenta",
  "block.minecraft.light_blue_bed": "jet blu clâr",
  "block.minecraft.yellow_bed": "jet zâl",
  "block.minecraft.lime_bed": "jet vert limon",
  "block.minecraft.pink_bed": "jet rose",
  "block.minecraft.gray_bed": "jet grîs",
  "block.minecraft.light_gray_bed": "jet grîs clâr",
  "block.minecraft.cyan_bed": "jet ciano",
  "block.minecraft.purple_bed": "jet viole",
  "block.minecraft.blue_bed": "jet blu",
  "block.minecraft.brown_bed": "jet maron",
  "block.minecraft.green_bed": "jet vert",
  "block.minecraft.red_bed": "jet ros",
  "block.minecraft.black_bed": "jet neri",
  "item.minecraft.cookie": "biscot",
  "item.minecraft.filled_map": "mape□#0",
  "item.minecraft.shears": "fuarpiis",
  "item.minecraft.melon_slice": "fete di angurie",
  "item.minecraft.dried_kelp": "alighe secjade",
  "item.minecraft.pumpkin_seeds": "semencis di coce",
  "item.minecraft.melon_seeds": "semencis di angurie",
  "item.minecraft.beef": "cjar di manç crude",
  "item.minecraft.cooked_beef": "bisteche",
  "item.minecraft.chicken": "poleç crût",
  "item.minecraft.cooked_chicken": "poleç cuet",
  "item.minecraft.rotten_flesh": "cjar fraide",
  "item.minecraft.ender_pearl": "perle dal end",
  "item.minecraft.blaze_rod": "vuiscje di blaze",
  "item.minecraft.ghast_tear": "lagrime di ghast",
  "item.minecraft.gold_nugget": "pepite di aur",
  "item.minecraft.nether_wart": "riçûl dal nether",
  "item.minecraft.potion": "pozion no fabricabile□nissun efiet",
  "item.minecraft.glass_bottle": "butilie",
  "item.minecraft.spider_eye": "voli di ragn",
  "item.minecraft.fermented_spider_eye": "voli di ragn fermentât",
  "item.minecraft.blaze_powder": "polvar di blaze",
  "item.minecraft.magma_cream": "creme di magme",
  "block.minecraft.brewing_stand": "lambic",
  "block.minecraft.cauldron": "cjalderon",
  "item.minecraft.ender_eye": "voli dal ender",
  "item.minecraft.glistering_melon_slice": "fete sflandorose di angurie",
  "item.minecraft.bat_spawn_egg": "ûf di nassite dal gnotul",
  "item.minecraft.bee_spawn_egg": "ûf di nassite de âf",
  "item.minecraft.blaze_spawn_egg": "ûf di nassite dal blaze",
  "item.minecraft.cat_spawn_egg": "ûf di nassite dal gjat",
  "item.minecraft.cave_spider_spawn_egg": "ûf di nassite dal ragn dai landris",
  "item.minecraft.chicken_spawn_egg": "ûf di nassite dal poleç",
  "item.minecraft.cod_spawn_egg": "ûf di nassite dal merluç",
  "item.minecraft.cow_spawn_egg": "ûf di nassite de vacje",
  "item.minecraft.creeper_spawn_egg": "ûf di nassite dal creeper",
  "item.minecraft.dolphin_spawn_egg": "ûf di nassite dal dolfin",
  "item.minecraft.donkey_spawn_egg": "ûf di nassite dal mus",
  "item.minecraft.drowned_spawn_egg": "ûf di nassite dal inneât",
  "item.minecraft.elder_guardian_spawn_egg": "ûf di nassite dal vuardian veteran",
  "item.minecraft.enderman_spawn_egg": "ûf di nassite dal enderman",
  "item.minecraft.endermite_spawn_egg": "ûf di nassite dal endermite",
  "item.minecraft.evoker_spawn_egg": "ûf di nassite dal evocadôr",
  "item.minecraft.fox_spawn_egg": "ûf di nassite de bolp",
  "item.minecraft.ghast_spawn_egg": "ûf di nassite dal ghast",
  "item.minecraft.guardian_spawn_egg": "ûf di nassite dal vuardian",
  "item.minecraft.hoglin_spawn_egg": "ûf di nassite dal hoglin",
  "item.minecraft.horse_spawn_egg": "ûf di nassite dal cjaval",
  "item.minecraft.husk_spawn_egg": "ûf di nassite dal zombi sec",
  "item.minecraft.llama_spawn_egg": "ûf di nassite dal lama",
  "item.minecraft.magma_cube_spawn_egg": "ûf di nassite dal cubul di magme",
  "item.minecraft.mooshroom_spawn_egg": "ûf di nassite dal mooshroom",
  "item.minecraft.mule_spawn_egg": "ûf di nassite dal mûl",
  "item.minecraft.ocelot_spawn_egg": "ûf di nassite dal gjat salvadi",
  "item.minecraft.panda_spawn_egg": "ûf di nassite dal panda",
  "item.minecraft.parrot_spawn_egg": "ûf di nassite dal pampagal",
  "item.minecraft.phantom_spawn_egg": "ûf di nassite dal phantom",
  "item.minecraft.pig_spawn_egg": "ûf di nassite dal purcit",
  "item.minecraft.piglin_spawn_egg": "ûf di nassite dal piglin",
  "item.minecraft.pillager_spawn_egg": "ûf di nassite dal sachizadôr",
  "item.minecraft.polar_bear_spawn_egg": "ûf di nassite dal ors polâr",
  "item.minecraft.pufferfish_spawn_egg": "ûf di nassite dal pes-bale",
  "item.minecraft.rabbit_spawn_egg": "ûf di nassite dal cunin",
  "item.minecraft.ravager_spawn_egg": "ûf di nassite dal devastadôr",
  "item.minecraft.salmon_spawn_egg": "ûf di nassite di salmon",
  "item.minecraft.sheep_spawn_egg": "ûf di nassite de piore",
  "item.minecraft.shulker_spawn_egg": "ûf di nassite dal shulker",
  "item.minecraft.silverfish_spawn_egg": "ûf di nassite dal pessut di arint",
  "item.minecraft.skeleton_spawn_egg": "ûf di nassite dal scheletri",
  "item.minecraft.skeleton_horse_spawn_egg": "ûf di nassite dal cjaval scheletric",
  "item.minecraft.slime_spawn_egg": "ûf di nassite de gjeladine",
  "item.minecraft.spider_spawn_egg": "ûf di nassite dal ragn",
  "item.minecraft.squid_spawn_egg": "ûf di nassite dal calamâr",
  "item.minecraft.stray_spawn_egg": "ûf di nassite dal scheletri vagabont",
  "item.minecraft.strider_spawn_egg": "ûf di nassite dal strider",
  "item.minecraft.trader_llama_spawn_egg": "ûf di nassite dal lama di marcjadant",
  "item.minecraft.tropical_fish_spawn_egg": "ûf di nassite dal pes tropicâl",
  "item.minecraft.turtle_spawn_egg": "ûf di nassite de copasse",
  "item.minecraft.vex_spawn_egg": "ûf di nassite dal vex",
  "item.minecraft.villager_spawn_egg": "ûf di nassite dal paisan",
  "item.minecraft.vindicator_spawn_egg": "ûf di nassite dal svindicadôr",
  "item.minecraft.wandering_trader_spawn_egg": "ûf di nassite dal vendidôr ambulant",
  "item.minecraft.witch_spawn_egg": "ûf di nassite de strie",
  "item.minecraft.wither_skeleton_spawn_egg": "ûf di nassite dal scheletri wither",
  "item.minecraft.wolf_spawn_egg": "ûf di nassite dal lôf",
  "item.minecraft.zoglin_spawn_egg": "ûf di nassite dal zoglin",
  "item.minecraft.zombie_spawn_egg": "ûf di nassite dal zombi",
  "item.minecraft.zombie_horse_spawn_egg": "ûf di nassite dal cjaval zombi",
  "item.minecraft.zombie_villager_spawn_egg": "ûf di nassite dal paisan zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "ûf di nassite dal piglin zombificât",
  "item.minecraft.experience_bottle": "pozion di esperience",
  "item.minecraft.fire_charge": "cjarie di fûc",
  "item.minecraft.writable_book": "libri e pene",
  "item.minecraft.written_book": "libri scrit",
  "item.minecraft.emerald": "smeralt",
  "item.minecraft.item_frame": "curnîs",
  "block.minecraft.flower_pot": "vâs",
  "item.minecraft.carrot": "carote",
  "item.minecraft.potato": "patate",
  "item.minecraft.baked_potato": "patate rustide",
  "item.minecraft.poisonous_potato": "patate velenose",
  "item.minecraft.map": "mape vueide",
  "item.minecraft.golden_carrot": "carote dorade",
  "block.minecraft.skeleton_skull": "crani di scheletri",
  "block.minecraft.wither_skeleton_skull": "crani di scheletri wither",
  "block.minecraft.player_head": "cjâf di zuiadôr",
  "block.minecraft.zombie_head": "cjâf di zombi",
  "block.minecraft.creeper_head": "cjâf di creeper",
  "block.minecraft.dragon_head": "cjâf di drâc",
  "item.minecraft.carrot_on_a_stick": "baston cu la carote",
  "item.minecraft.warped_fungus_on_a_stick": "baston cun fonc disnaturât",
  "item.minecraft.nether_star": "stele dal nether",
  "item.minecraft.pumpkin_pie": "torte di coce",
  "item.minecraft.firework_rocket": "fusete",
  "item.minecraft.firework_star": "stele de fusete",
  "item.minecraft.enchanted_book": "libri incjantât",
  "item.minecraft.nether_brick": "modon dal nether",
  "item.minecraft.quartz": "cuarç dal nether",
  "item.minecraft.tnt_minecart": "carel minerari cun tnt",
  "item.minecraft.hopper_minecart": "carel minerari cun tramuele",
  "item.minecraft.prismarine_shard": "toc di prismarine",
  "item.minecraft.prismarine_crystals": "cristai di prismarine",
  "item.minecraft.rabbit": "cjar di cunin crude",
  "item.minecraft.cooked_rabbit": "cjar di cunin cuete",
  "item.minecraft.rabbit_stew": "stofât di cunin",
  "item.minecraft.rabbit_foot": "talpe di cunin",
  "item.minecraft.rabbit_hide": "piel di cunin",
  "item.minecraft.armor_stand": "picjot",
  "item.minecraft.iron_horse_armor": "furniment in fier pal cjaval",
  "item.minecraft.golden_horse_armor": "furniment in aur pal cjaval",
  "item.minecraft.diamond_horse_armor": "furniment in diamant pal cjaval",
  "item.minecraft.leather_horse_armor": "furniment in corean pal cjaval",
  "item.minecraft.lead": "sguinçâl",
  "item.minecraft.name_tag": "etichete pal non",
  "item.minecraft.command_block_minecart": "carel minerari cun bloc comants",
  "item.minecraft.mutton": "cjar di piore crude",
  "item.minecraft.cooked_mutton": "cjar di piore cuete",
  "block.minecraft.white_banner": "stendart blanc",
  "block.minecraft.orange_banner": "stendart naranç",
  "block.minecraft.magenta_banner": "stendart magenta",
  "block.minecraft.light_blue_banner": "stendart blu clâr",
  "block.minecraft.yellow_banner": "stendart zâl",
  "block.minecraft.lime_banner": "stendart vert limon",
  "block.minecraft.pink_banner": "stendart rose",
  "block.minecraft.gray_banner": "stendart grîs",
  "block.minecraft.light_gray_banner": "stendart grîs clâr",
  "block.minecraft.cyan_banner": "stendart ciano",
  "block.minecraft.purple_banner": "stendart viole",
  "block.minecraft.blue_banner": "stendart blu",
  "block.minecraft.brown_banner": "stendart maron",
  "block.minecraft.green_banner": "stendart vert",
  "block.minecraft.red_banner": "stendart ros",
  "block.minecraft.black_banner": "stendart neri",
  "item.minecraft.end_crystal": "cristal dal end",
  "item.minecraft.chorus_fruit": "pome corâl",
  "item.minecraft.popped_chorus_fruit": "pome corâl sclopade",
  "item.minecraft.beetroot": "jerbe rave",
  "item.minecraft.beetroot_seeds": "semencis di jerbe rave",
  "item.minecraft.beetroot_soup": "sope di jerbe rave",
  "item.minecraft.dragon_breath": "flât di drâc",
  "item.minecraft.splash_potion": "pozion di tîr no fabricabile□nissun efiet",
  "item.minecraft.spectral_arrow": "frece spetrâl",
  "item.minecraft.tipped_arrow": "frece imbombade no fabricabile□nissun efiet",
  "item.minecraft.lingering_potion": "pozion persistente no fabricabile□nissun efiet",
  "item.minecraft.shield": "scût",
  "item.minecraft.elytra": "elitris",
  "item.minecraft.spruce_boat": "barcje di peç",
  "item.minecraft.birch_boat": "barcje di bedoi",
  "item.minecraft.jungle_boat": "barcje di len di jungle",
  "item.minecraft.acacia_boat": "barcje di agacie",
  "item.minecraft.dark_oak_boat": "barcje di rôl scûr",
  "item.minecraft.totem_of_undying": "totem de imortalitât",
  "item.minecraft.shulker_shell": "scus dal shulker",
  "item.minecraft.iron_nugget": "pepite di fier",
  "item.minecraft.knowledge_book": "libri dal savê",
  "item.minecraft.debug_stick": "stec pal debug",
  "item.minecraft.music_disc_13": "disc musicâl□c418 - 13",
  "item.minecraft.music_disc_cat": "disc musicâl□c418 - cat",
  "item.minecraft.music_disc_blocks": "disc musicâl□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disc musicâl□c418 - chirp",
  "item.minecraft.music_disc_far": "disc musicâl□c418 - far",
  "item.minecraft.music_disc_mall": "disc musicâl□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disc musicâl□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disc musicâl□c418 - stal",
  "item.minecraft.music_disc_strad": "disc musicâl□c418 - strad",
  "item.minecraft.music_disc_ward": "disc musicâl□c418 - ward",
  "item.minecraft.music_disc_11": "disc musicâl□c418 - 11",
  "item.minecraft.music_disc_wait": "disc musicâl□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disc musicâl□lena raine - pigstep",
  "item.minecraft.trident": "fossigne□□te man principâl:□+8 dams di atac□-2.9 velocitât di atac",
  "item.minecraft.phantom_membrane": "membrane di phantom",
  "item.minecraft.nautilus_shell": "cape di nautil",
  "item.minecraft.heart_of_the_sea": "cûr dal mâr",
  "item.minecraft.crossbow": "balestre",
  "item.minecraft.suspicious_stew": "sope suspiete",
  "block.minecraft.loom": "telâr",
  "item.minecraft.flower_banner_pattern": "model di stendart□rose",
  "item.minecraft.creeper_banner_pattern": "model di stendart□muse di creeper",
  "item.minecraft.skull_banner_pattern": "model di stendart□crani",
  "item.minecraft.mojang_banner_pattern": "model di stendart□logo",
  "item.minecraft.globe_banner_pattern": "model di stendart□globi",
  "item.minecraft.piglin_banner_pattern": "model di stendart□music",
  "block.minecraft.composter": "compostiere",
  "block.minecraft.barrel": "caratel",
  "block.minecraft.smoker": "fumadôr",
  "block.minecraft.blast_furnace": "for a fusion",
  "block.minecraft.cartography_table": "banc dal cartograf",
  "block.minecraft.fletching_table": "banc pes frecis",
  "block.minecraft.grindstone": "muele",
  "block.minecraft.lectern": "letorin",
  "block.minecraft.smithing_table": "banc dal fari",
  "block.minecraft.stonecutter": "taiadôr di pieris",
  "block.minecraft.bell": "cjampane",
  "block.minecraft.lantern": "ferâl",
  "block.minecraft.soul_lantern": "ferâl des animis",
  "item.minecraft.sweet_berries": "pomulis dolcis",
  "block.minecraft.campfire": "fogaron",
  "block.minecraft.soul_campfire": "fogaron des animis",
  "block.minecraft.shroomlight": "fonclum",
  "item.minecraft.honeycomb": "celet",
  "block.minecraft.bee_nest": "bôç",
  "block.minecraft.beehive": "bôç artificiâl",
  "item.minecraft.honey_bottle": "butilie di mîl",
  "block.minecraft.honey_block": "bloc di mîl",
  "block.minecraft.honeycomb_block": "bloc di celets",
  "block.minecraft.lodestone": "magnetite",
  "block.minecraft.netherite_block": "bloc di netherite",
  "block.minecraft.ancient_debris": "rudinaçs antîcs",
  "block.minecraft.target": "bersai",
  "block.minecraft.crying_obsidian": "ossidiane vaiulinte",
  "block.minecraft.blackstone": "pierenere",
  "block.minecraft.blackstone_slab": "lastre di pierenere",
  "block.minecraft.blackstone_stairs": "scjalins di pierenere",
  "block.minecraft.gilded_blackstone": "pierenere dorade",
  "block.minecraft.polished_blackstone": "pierenere lustrade",
  "block.minecraft.polished_blackstone_slab": "lastre di pierenere lustrade",
  "block.minecraft.polished_blackstone_stairs": "scjalins di pierenere lustrade",
  "block.minecraft.chiseled_polished_blackstone": "pierenere lustrade ceselade",
  "block.minecraft.polished_blackstone_bricks": "modons di pierenere lustrade",
  "block.minecraft.polished_blackstone_brick_slab": "lastre di modons di pierenere lustrade",
  "block.minecraft.polished_blackstone_brick_stairs": "scjalins di modons di pierenere lustrade",
  "block.minecraft.cracked_polished_blackstone_bricks": "modons di pierenere lustrade crepade",
  "block.minecraft.respawn_anchor": "ancure di rinassite",
}
export const fur_it = items; 
